import styled from "styled-components";

export const VideoFrame = styled.div`
  padding: ${(props) => (props.isTesting ? "0" : "56.25% 0 0 0")};
  position: relative;

  iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border: none;
  }
`;

export const WarningCard = styled.div`
  background-color: #ffffff;
  padding: 40px;
  border-radius: 12px;
  max-width: 550px;
  width: 90%;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
`;

export const WarningTitle = styled.h3`
  color: #333333;
  margin-top: 15px;
  margin-bottom: 10px;
`;

export const WarningDescription = styled.p`
  margin-bottom: 15px;
  color: #666666;
  text-align: center;
`;

export const WarningInfoBox = styled.div`
  background-color: #f9f9f9;
  padding: 15px;
  border-radius: 8px;
  margin-bottom: 25px;
  font-size: 14px;
  color: #555555;
  text-align: center;
  border: 1px solid #eeeeee;

  p {
    margin: 0;
  }
`;

export const WarningActions = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
`;
